/* covered.ro — Hero: pointer tilt for the phone fan (fine pointers only). */
(() => {
  if (customElements.get('cv-hero-visual')) return;

  const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const clamp = (v) => Math.max(-1, Math.min(1, v));
  const listen = (mq, fn) => (mq.addEventListener ? mq.addEventListener('change', fn) : mq.addListener(fn));
  const unlisten = (mq, fn) => (mq.removeEventListener ? mq.removeEventListener('change', fn) : mq.removeListener(fn));

  class CvHeroVisual extends HTMLElement {
    connectedCallback() {
      this.section = this.closest('.cv-hero') || this;
      this.target = { x: 0, y: 0 };
      this.current = { x: 0, y: 0 };
      this.frame = 0;

      this.onMove = this.onMove.bind(this);
      this.onLeave = this.onLeave.bind(this);
      this.tick = this.tick.bind(this);
      this.setup = this.setup.bind(this);

      // Pause the idle float while the hero is off screen.
      if ('IntersectionObserver' in window) {
        this.visibility = new IntersectionObserver(([entry]) => {
          this.section.classList.toggle('is-offscreen', !entry.isIntersecting);
        });
        this.visibility.observe(this.section);
      }

      listen(finePointer, this.setup);
      listen(reduceMotion, this.setup);
      this.setup();
    }

    disconnectedCallback() {
      this.teardown();
      if (this.visibility) this.visibility.disconnect();
      unlisten(finePointer, this.setup);
      unlisten(reduceMotion, this.setup);
    }

    get enabled() {
      return (
        this.hasAttribute('data-tilt') &&
        !!this.querySelector('.cv-hero__fan') &&
        finePointer.matches &&
        !reduceMotion.matches &&
        !document.body.classList.contains('disable-animations')
      );
    }

    setup() {
      this.teardown();
      if (!this.enabled) {
        this.section.style.removeProperty('--mx');
        this.section.style.removeProperty('--my');
        return;
      }
      this.section.addEventListener('pointermove', this.onMove, { passive: true });
      this.section.addEventListener('pointerleave', this.onLeave, { passive: true });
    }

    teardown() {
      this.section.removeEventListener('pointermove', this.onMove);
      this.section.removeEventListener('pointerleave', this.onLeave);
      cancelAnimationFrame(this.frame);
      this.frame = 0;
    }

    onMove(event) {
      if (event.pointerType === 'touch') return;
      const rect = this.getBoundingClientRect();
      const cx = rect.left + rect.width / 2;
      const cy = rect.top + rect.height / 2;
      this.target.x = clamp((event.clientX - cx) / (window.innerWidth * 0.5));
      this.target.y = clamp((event.clientY - cy) / (window.innerHeight * 0.5));
      this.start();
    }

    onLeave() {
      this.target.x = 0;
      this.target.y = 0;
      this.start();
    }

    start() {
      if (!this.frame) this.frame = requestAnimationFrame(this.tick);
    }

    tick() {
      const c = this.current;
      const t = this.target;
      c.x += (t.x - c.x) * 0.08;
      c.y += (t.y - c.y) * 0.08;
      this.section.style.setProperty('--mx', c.x.toFixed(4));
      this.section.style.setProperty('--my', c.y.toFixed(4));
      if (Math.abs(t.x - c.x) + Math.abs(t.y - c.y) > 0.001) {
        this.frame = requestAnimationFrame(this.tick);
      } else {
        this.frame = 0;
      }
    }
  }

  customElements.define('cv-hero-visual', CvHeroVisual);
})();
